import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-overlay">
      <div className="cookie-consent-banner">
        <div className="cookie-consent-content">
          <div className="cookie-consent-text-container">
            <p className="cookie-consent-text">
              Utilizamos cookies para mejorar tu experiencia de navegación y analizar nuestro tráfico.
              Al hacer clic en "Aceptar", das tu consentimiento para el uso de cookies.
            </p>
            <Link to="/configuracion-cookies" className="cookie-consent-link">
              Configurar Cookies
            </Link>
          </div>
          <div className="cookie-consent-buttons">
            <button
              className="cookie-consent-btn cookie-consent-accept"
              onClick={handleAccept}
            >
              Aceptar
            </button>
            <button
              className="cookie-consent-btn cookie-consent-reject"
              onClick={handleReject}
            >
              Rechazar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
